
import { useFormContext } from 'react-hook-form';
// @mui
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Unstable_Grid2';
import CardHeader from '@mui/material/CardHeader';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { RHFUpload, RHFTextField, RHFAutocomplete } from 'src/components/hook-form';
import { STATUS_OPTIONS } from 'src/constants/status';
// types
import { VuonTrong } from 'src/types/vuontrong';

// ----------------------------------------------------------------------

type Props = {
  gardens: VuonTrong[];
  isEdit?: boolean;
};

export default function LoSamDetailForm({ gardens, isEdit }: Props) {
  const mdUp = useResponsive('up', 'md');

  const { watch, setValue } = useFormContext();

  const values = watch();

  const handleDrop = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];

    const newFile = Object.assign(file, {
      preview: URL.createObjectURL(file),
    });

    if (file) {
      setValue('coverUrl', newFile, { shouldValidate: true });
    }
  };

  const handleRemoveFile = () => {
    setValue('coverUrl', null);
  };

  return (
    <>
      {mdUp && (
        <Grid md={3}>
          <Typography variant="h6" sx={{ mb: 0.5 }}>
            Chi tiết
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Thông tin cơ bản của lô sâm...
          </Typography>
        </Grid>
      )}

      <Grid xs={12} md={9}>
        <Card>
          {!mdUp && <CardHeader title="Chi tiết" />}

          <Stack spacing={3} sx={{ p: 3 }}>
            <FormControl fullWidth>
              <InputLabel>Vườn trồng</InputLabel>
              <Select
                name="vuonTrong_ID"
                value={values.vuonTrong_ID}
                label="Vườn trồng"
                onChange={(event) => setValue('vuonTrong_ID', Number(event.target.value))}
                disabled={isEdit}
              >
                {gardens.map((g) => (
                  <MenuItem key={g.vuonTrong_ID} value={g.vuonTrong_ID}>
                    {g.tenVuon}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <RHFTextField name="tenLo" label="Tên lô" />

            <RHFTextField name="maLo" label="Mã lô" />

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <RHFTextField
                name="soHang"
                label="Số hàng"
                type="number"
              />

              <RHFTextField
                name="soCot"
                label="Số cột"
                type="number"
              />
            </Stack>

            <RHFTextField
              name="dienTich"
              label="Diện tích (m²)"
              type="number"
            />
            <RHFTextField name="loai" label="Loại" />

            <RHFTextField
              name="ghiChu"
              label="Ghi chú"
              multiline
              rows={3}
            />
              <RHFAutocomplete
                name="trangThai"
                label="Trạng thái"
                options={STATUS_OPTIONS}
                getOptionLabel={(opt) => typeof opt === 'string' ? opt : opt.label}
                isOptionEqualToValue={(opt, val) => (typeof val === 'number' ? opt.value === val : opt.value === val.value)}
                value={STATUS_OPTIONS.find((o) => o.value === watch('trangThai')) || null}
                onChange={(e, newValue) => setValue('trangThai', newValue ? (newValue as any).value : 1, { shouldValidate: true })}
                renderOption={(props, option) => (
                  <li {...props} key={option.value}>{option.label}</li>
                )}
              />

            <Stack spacing={1.5}>
              <Typography variant="subtitle2">Ảnh bìa</Typography>
              <RHFUpload
                name="coverUrl"
                maxSize={3145728}
                onDrop={handleDrop}
                onDelete={handleRemoveFile}
              />
            </Stack>
          </Stack>
        </Card>
      </Grid>
    </>
  );
}
